import sha256 from "crypto-js/sha256";

import { Photo } from "components/PhotoUpload/types";

import { MappedUploadedPhotos } from "../../pages/VehicleAnalysis/types";

export const mockAdditionalDocuments = [
  {
    id: "0e5d1509-7e50-4895-8e8e-55db164f16fc",
    type: Photo.Additional,
    base64: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAADZ",
    src: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAADZ",
    alt: "additional photo to upload number 1",
    clientImageId: "additionalPhotos-0e5d1509-7e50-4895-8e8e-55db164f16fc.jpeg",
    hash: sha256("data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAADZ").toString(),
  },
];

export const mockDamagePhotos = [
  {
    id: "kjb4235-123e-4895-8e8e-55db164f16fc",
    type: Photo.Damage,
    base64: "data:image/jpeg;base64,/9j/4AAQSkZJRgABBAQERSCAQADSFLKNADZ",
    src: "data:image/jpeg;base64,/9j/4AAQSkZJRgABBAQERSCAQADSFLKNADZ",
    alt: "damage photo to upload number 1",
    clientImageId: "damagePhotos-kjb4235-123e-4895-8e8e-55db164f16fc.jpeg",
    hash: sha256("data:image/jpeg;base64,/9j/4AAQSkZJRgABBAQERSCAQADSFLKNADZ").toString(),
  },
];

export const mockVehiclePhotos = [
  {
    id: "2n1j4k1j-kj12-4895-8e8e-nl12njk123",
    type: Photo.Vehicle,
    base64: "data:image/jpeg;base64,/9j/KSJBFSFBFKSJB893AKJD",
    src: "data:image/jpeg;base64,/9j/KSJBFSFBFKSJB893AKJD",
    alt: "vehicle photo to upload number 1",
    clientImageId: "vehiclePhotos-2n1j4k1j-kj12-4895-8e8e-nl12njk123.jpeg",
    hash: sha256("data:image/jpeg;base64,/9j/KSJBFSFBFKSJB893AKJD").toString(),
  },
];

export const mockMileagePhotos = [
  {
    id: "67be736d-3d49-4b40-9e8b-a69266eb45e7",
    type: Photo.Mileage,
    base64: "data:image/jpeg;base64,/9j/KSJBFSFBFKSJB8D3AKJD",
    src: "data:image/jpeg;base64,/9j/KSJBFSFBFKSJB8D3AKJD",
    alt: "vehicle photo to upload number 1",
    clientImageId: "mileagePhotos-67be736d-3d49-4b40-9e8b-a69266eb45e7.jpeg",
    hash: sha256("data:image/jpeg;base64,/9j/KSJBFSFBFKSJB8D3AKJD").toString(),
  },
];

export const MOCK_UPLOADED_PHOTOS: MappedUploadedPhotos = {
  [mockDamagePhotos[0].id]: {
    id: mockDamagePhotos[0].id,
    type: mockDamagePhotos[0].type,
    path: "http://car-owner-app-s3-bucket-localstack.localhost.localstack.cloud:4566/images/nish/daaedb9d5623.jpg",
    format: "jpeg",
    bucket: "car-owner-app-s3-bucket-localstack",
    key: "images/nish/daaedb9d5623.jpg",
    clientImageId: `damagePhotos-${mockDamagePhotos[0].id}.jpeg`,
  },
  [mockVehiclePhotos[0].id]: {
    id: mockVehiclePhotos[0].id,
    type: mockVehiclePhotos[0].type,
    path: "http://car-owner-app-s3-bucket-localstack.localhost.localstack.cloud:4566/images/nish/daaedb9d5623.jpg",
    format: "jpeg",
    bucket: "car-owner-app-s3-bucket-localstack",
    key: "images/nish/daaedb9d5623.jpg",
    clientImageId: `vehiclePhotos-${mockVehiclePhotos[0].id}.jpeg`,
  },
  [mockAdditionalDocuments[0].id]: {
    id: mockAdditionalDocuments[0].id,
    type: mockAdditionalDocuments[0].type,
    path: "http://car-owner-app-s3-bucket-localstack.localhost.localstack.cloud:4566/images/nish/daaedb9d5623.jpg",
    format: "jpeg",
    bucket: "car-owner-app-s3-bucket-localstack",
    key: "images/nish/daaedb9d5623.jpg",
    clientImageId: `additionalPhotos-${mockAdditionalDocuments[0].id}.jpeg`,
  },
  [mockMileagePhotos[0].id]: {
    id: mockMileagePhotos[0].id,
    type: mockMileagePhotos[0].type,
    path: "http://car-owner-app-s3-bucket-localstack.localhost.localstack.cloud:4566/images/nish/daaedb9d5623.jpg",
    format: "jpeg",
    bucket: "car-owner-app-s3-bucket-localstack",
    key: "images/nish/daaedb9d5623.jpg",
    clientImageId: `mileagePhotos-${mockMileagePhotos[0].id}.jpeg`,
  },
};

export const mockVehicleQuestions = {
  haveAirbagsDeployed: false,
  isVehicleDrivable: false,
};


export const mockVinValue = "4Y1SL65848Z411439"
